// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Mgwa","videoContainer":"Home_videoContainer__0n81D","video":"Home_video__1Quq3","summary":"Home_summary__9S+ye"};